import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { environment } from '@environments/environment';
import { ROUTES_CONSTANTS } from '@shared/configs';

@Injectable()
export class RedirectionService {
  apiUrl = environment.apiUrl;
  private messageSource = new BehaviorSubject(null);
  currentMessage = this.messageSource.asObservable();
  stackUrls: string[] = [];

  constructor(private router: Router) {}

  changeMessage(response: string) {
    this.messageSource.next(response);
  }

  navigateTo(url: string): void {
    if (url === ROUTES_CONSTANTS.DISPERSION_METHOD) {
      this.router.navigate([ROUTES_CONSTANTS.DISPERSION_METHOD]);
      return;
    }

    if (this.isValidUrl(url)) {
      window.location.href = url;
    } else {
      this.registerUrl(url);
      this.router.navigate([url]);
    }
  }

  isValidUrl(url: string) {
    try {
      new URL(url);
    } catch (_) {
      return false;
    }

    return true;
  }

  registerUrl(url: string) {
    this.stackUrls.push(url);
  }
  getLastRegisteredUrl(): string {
    return this.stackUrls[this.stackUrls.length - 2];
  }
  public redirectToLandingRP(): void {
    window.location.href = `${environment.landingRapiplazo}`;
  }

  public redirectToLandingRF(): void {
    window.location.href = `${environment.landingRapiflex}/rapiflex`;
  }
}
